module.exports = __webpack_public_path__ + "static/work46-6f74f89017e43cf7abdb5244befa0bbd.jpg";